module.exports = __webpack_public_path__ + "img/cart-f.102aee48.svg";